import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NotAuthorizedTwotoneStandard.js";
import i from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(i, n(e, {
    icon: d
  }), null);
};
t.displayName = "NotAuthorizedTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
